module.exports = __webpack_public_path__ + "img/Pista_36_2.1262d696.png";